import moment from 'moment';

import { round } from 'lodash-es';

export const createReport = (reportData, settings, generationParams) => {
  const { days, resources, workHourType } = reportData;
  const {
    isRecordBasedReductions,
    paidCoffeeBreakMinutes,
    automaticMealBreakReductionLengthHours,
  } = generationParams;

  const paidCoffeeBreakLengthValueInHours = paidCoffeeBreakMinutes
    ? Number(paidCoffeeBreakMinutes) / 60
    : 0;

  let weeks = {};

  Object.keys(days).map((day) => {
    const week1 = moment(day).endOf('isoWeek').format('YYYY[W]WW');
    const week2 = moment(day).add(1, 'weeks').format('YYYY[W]WW');
    const weekKey = `${week1}-${week2}`;
    if (
      !Object.keys(weeks).some(function (k) {
        return ~k.indexOf(week1);
      })
    ) {
      weeks[weekKey] = {};
    }
  });

  Object.keys(days).map(function (day) {
    const dayWeek = moment(day).endOf('isoWeek').format('YYYY[W]WW');
    Object.keys(weeks).map(function (week) {
      if (week.includes(dayWeek)) {
        if (!(day in weeks[week])) weeks[week][day] = days[day];
      }
    });
  });

  const mainTableHeader = (_days) => {
    let titles3 = [];

    if (settings.filetype === 'PDF') {
      titles3 = titles3.map((x) =>
        x ? { text: x, style: 'tableHeader' } : ''
      );
    }

    let totalHours = 0;
    let hasUserDataInPeriod = false;
    Object.keys(_days).map(function (key) {
      const d = moment(key);

      Object.keys(_days[key]).map((resource) => {
        totalHours += _days[key][resource].hours;
        hasUserDataInPeriod = true;
      });

      if (settings.filetype === 'excel') {
        titles3.push(`${d.date()}.${d.month() + 1}.`);
      } else {
        titles3.push(
          `${d.date()}.${d.month() + 1}._ISOWEEKDAY-${d.isoWeekday()}`
        );
      }
    });

    if (totalHours > 0 || hasUserDataInPeriod) {
      return titles3;
    } else {
      return [];
    }
  };

  let userTotalWorkAmountsByUserId = {};

  let totalProjectHoursByUserId = {};

  let totalAssignmentHoursByUserId = {};

  let eachDayTotalHoursByUserId = {};

  const mainTableRows = (_days) => {
    let rows = [];
    Object.keys(resources).forEach((resourceKey) => {
      let workdays = 0;
      let totalsum = 0;
      let totalSumWithRecordBasedReductions = 0;
      let autoReducedSum = 0;

      const resourceData = resources[resourceKey];

      const userSalaryType = resourceData.resource.baseSalaryType;

      if (userSalaryType === 'MONTHLY') {
        // skip monthly wage user salary rows for now
        return;
      }

      let resourceName = `${resourceData.resource.firstName} ${resourceData.resource.lastName}`;
      if (settings.lastNameFirst) {
        resourceName = `${resourceData.resource.lastName} ${resourceData.resource.firstName}`;
      }
      let columns = [resourceName, '', '', ''];

      let workHoursByProjectId = {};

      let workHoursByAssignmentId = {};

      let madeAutomaticProjectReductionDays = [];

      let madeAutomaticAssignmentReductionDays = [];

      Object.entries(_days).forEach(([dayKey, dayResources]) => {
        if (dayResources[resourceKey] && dayResources[resourceKey].hours > 0) {
          const dayReduction = dayResources[resourceKey].reduction;

          const userWorkHoursForThisDay = dayResources[resourceKey].hours;

          const userHasWorkOrProjectWorkThisDay =
            dayResources[resourceKey].hours > 0;

          if (userHasWorkOrProjectWorkThisDay) {
            let daySum;

            const workTypeValue = userWorkHoursForThisDay
              ? userWorkHoursForThisDay
              : 0;

            let thisDayEffectiveWorkValue = 0;

            if (workHourType === 'ALL') {
              workdays += 1;
              const totalWork = workTypeValue;
              const totalReductions = dayReduction;

              totalsum += totalWork;
              daySum = totalWork;

              const totalEffectiveWorkValue = totalWork - totalReductions;

              autoReducedSum += totalEffectiveWorkValue;

              thisDayEffectiveWorkValue = totalEffectiveWorkValue;
            } else {
              if (workHourType === 'WORK') {
                totalsum += workTypeValue;
                daySum = workTypeValue;

                const totalEffectiveWorkValue = workTypeValue - dayReduction;

                autoReducedSum += totalEffectiveWorkValue;

                thisDayEffectiveWorkValue = totalEffectiveWorkValue;

                if (workTypeValue > 0) {
                  workdays += 1;
                }
              }
            }

            if (!eachDayTotalHoursByUserId[resourceKey]) {
              eachDayTotalHoursByUserId[resourceKey] = [];
            }

            const thisDayResourceData = days[dayKey][resourceKey];

            eachDayTotalHoursByUserId[resourceKey].push({
              day: dayKey,
              hours: isRecordBasedReductions
                ? daySum - thisDayResourceData.reduction
                : thisDayEffectiveWorkValue,
              eachAssignmentHours: thisDayResourceData.assignmentHours,
            });

            totalSumWithRecordBasedReductions +=
              daySum - thisDayResourceData.reduction;

            const daySumValue = Number(daySum) > 0.01 ? daySum.toFixed(2) : '';

            columns.push(daySumValue);
          } else {
            columns.push('');
          }
        } else {
          columns.push('');
        }

        const workedProjects = resourceData.workedProjects;

        const workedAssignments = resourceData.workedAssignments;

        workedProjects.forEach((project) => {
          if (!workHoursByProjectId[project.projectId]) {
            workHoursByProjectId[project.projectId] = {
              projectName: project.projectName,
              projectId: project.projectId,
              reducedTotalHours: 0,
              totalHours: 0,
              totalWorkDays: 0,
              allowanceRows: [],
              dayHourCells: [],
            };
          }

          const thisResourceProjectAdditionalSalaries =
            resourceData.additionalSalariesByProjectId[project.projectId];

          if (thisResourceProjectAdditionalSalaries) {
            workHoursByProjectId[project.projectId].allowanceRows =
              Object.values(thisResourceProjectAdditionalSalaries);
          }

          const thisResourceWorkForDay = _days[dayKey][resourceKey];

          if (thisResourceWorkForDay) {
            const thisDayProjectHours = _days[dayKey][resourceKey].projectHours;

            const reductionsForDay =
              _days[dayKey][resourceKey].projectHours[project.projectId] &&
              _days[dayKey][resourceKey].projectHours[project.projectId]
                .reductions;

            let fullReductions = 0;

            if (isRecordBasedReductions && reductionsForDay) {
              fullReductions =
                reductionsForDay.BREAK + reductionsForDay.BREAK_MEAL;
            }
            if (
              Object.keys(thisResourceWorkForDay.projectHours).includes(
                project.projectId
              )
            ) {
              const foundWorkHourValue =
                thisResourceWorkForDay.projectHours[project.projectId].hours;

              workHoursByProjectId[project.projectId].dayHourCells.push(
                round(foundWorkHourValue, 2)
              );
              workHoursByProjectId[project.projectId].totalHours += round(
                foundWorkHourValue,
                2
              );

              const userWorkHoursForThisDay = dayResources[resourceKey].hours;

              const workTypeValue = userWorkHoursForThisDay
                ? userWorkHoursForThisDay
                : 0;
              const projectWorkTypeValue = userWorkHoursForThisDay
                ? userWorkHoursForThisDay
                : 0;

              if (true) {
                if (
                  !isRecordBasedReductions &&
                  (workTypeValue >= 6 || projectWorkTypeValue >= 6)
                ) {
                  const isExistingProjectHoursForDayWithMealBreakReduction =
                    Object.values(thisDayProjectHours).some(
                      (projectHours) =>
                        projectHours.reductions.AUTOMATIC_MEAL_BREAK_REDUCTION >
                        0
                    );

                  if (!madeAutomaticProjectReductionDays.includes(dayKey)) {
                    if (reductionsForDay.AUTOMATIC_MEAL_BREAK_REDUCTION > 0) {
                      fullReductions =
                        reductionsForDay.AUTOMATIC_MEAL_BREAK_REDUCTION;
                      madeAutomaticProjectReductionDays.push(dayKey);
                    } else if (
                      foundWorkHourValue > 1 &&
                      !isExistingProjectHoursForDayWithMealBreakReduction
                    ) {
                      fullReductions = automaticMealBreakReductionLengthHours;
                      madeAutomaticProjectReductionDays.push(dayKey);
                    }
                  }
                }
              }

              const reducedHours = foundWorkHourValue - fullReductions;

              workHoursByProjectId[project.projectId].reducedTotalHours +=
                reducedHours;

              workHoursByProjectId[project.projectId].totalWorkDays += 1;
            } else {
              workHoursByProjectId[project.projectId].dayHourCells.push('');
            }
          } else {
            workHoursByProjectId[project.projectId].dayHourCells.push('');
          }
        });

        workedAssignments.forEach((assignment) => {
          if (!workHoursByAssignmentId[assignment.assignmentId]) {
            workHoursByAssignmentId[assignment.assignmentId] = {
              projectId: assignment.projectId,
              assignmentName: assignment.assignmentName,
              assignmentId: assignment.assignmentId,
              jydacomAssignmentId: assignment.jydacomAssignmentId,
              jydacomAssignmentCode: assignment.jydacomAssignmentCode,
              reducedTotalHours: 0,
              totalHours: 0,
              totalWorkDays: 0,
              dayHourCells: [],
            };
          }

          const thisResourceWorkForDay = _days[dayKey][resourceKey];

          if (thisResourceWorkForDay) {
            const thisDayAssignmentHours =
              _days[dayKey][resourceKey].assignmentHours;

            const reductionsForDay =
              _days[dayKey][resourceKey].assignmentHours[
                assignment.assignmentId
              ] &&
              _days[dayKey][resourceKey].assignmentHours[
                assignment.assignmentId
              ].reductions;

            let fullReductions = 0;

            if (isRecordBasedReductions && reductionsForDay) {
              fullReductions =
                reductionsForDay.BREAK + reductionsForDay.BREAK_MEAL;
            }
            if (
              Object.keys(thisResourceWorkForDay.assignmentHours).includes(
                assignment.assignmentId
              )
            ) {
              const foundWorkHourValue =
                thisResourceWorkForDay.assignmentHours[assignment.assignmentId]
                  .hours;

              workHoursByAssignmentId[
                assignment.assignmentId
              ].dayHourCells.push(round(foundWorkHourValue, 2));
              workHoursByAssignmentId[assignment.assignmentId].totalHours +=
                round(foundWorkHourValue, 2);

              const userWorkHoursForThisDay = dayResources[resourceKey].hours;

              const userHasWorkOrProjectWorkThisDay =
                dayResources[resourceKey].hours > 0;

              const workTypeValue = userWorkHoursForThisDay
                ? userWorkHoursForThisDay
                : 0;
              const projectWorkTypeValue = userWorkHoursForThisDay
                ? userWorkHoursForThisDay
                : 0;

              if (userHasWorkOrProjectWorkThisDay) {
                if (
                  !isRecordBasedReductions &&
                  (workTypeValue >= 6 || projectWorkTypeValue >= 6)
                ) {
                  const isExistingAssignmentHoursForDayWithMealBreakReduction =
                    Object.values(thisDayAssignmentHours).some(
                      (assignmentHours) =>
                        assignmentHours.reductions
                          .AUTOMATIC_MEAL_BREAK_REDUCTION > 0
                    );

                  if (!madeAutomaticAssignmentReductionDays.includes(dayKey)) {
                    if (reductionsForDay.AUTOMATIC_MEAL_BREAK_REDUCTION > 0) {
                      fullReductions =
                        reductionsForDay.AUTOMATIC_MEAL_BREAK_REDUCTION;
                      madeAutomaticAssignmentReductionDays.push(dayKey);
                    } else if (
                      foundWorkHourValue > 1 &&
                      !isExistingAssignmentHoursForDayWithMealBreakReduction
                    ) {
                      fullReductions = automaticMealBreakReductionLengthHours;
                      madeAutomaticAssignmentReductionDays.push(dayKey);
                    }
                  }
                }
              }

              const reducedHours = foundWorkHourValue - fullReductions;

              workHoursByAssignmentId[
                assignment.assignmentId
              ].reducedTotalHours += reducedHours;

              workHoursByAssignmentId[assignment.assignmentId].totalWorkDays +=
                1;
            } else {
              workHoursByAssignmentId[
                assignment.assignmentId
              ].dayHourCells.push('');
            }
          } else {
            workHoursByAssignmentId[assignment.assignmentId].dayHourCells.push(
              ''
            );
          }
        });
      });

      if (
        totalsum > 0 ||
        Object.keys(resourceData.additionalSalaries.length > 0)
      ) {
        const finalReducedSum = !isRecordBasedReductions
          ? autoReducedSum.toFixed(2)
          : totalSumWithRecordBasedReductions.toFixed(2);

        const userPersonNumber = resourceData.resource.personNumber;

        const salaryUnitPrice = resourceData.resource.salaryHour;

        const userHourlySalary = resourceData.resource.salaryHour || 0;
        // const userMonthlySalary = resourceData.resource.salaryMonth || 0;

        const monthSalaryFrequency = resourceData.resource.monthSalaryFrequency;

        columns[1] = workdays;
        columns[2] = totalsum.toFixed(2);
        columns[3] = finalReducedSum;

        rows.push({
          userId: resourceKey,
          cells: columns,
          baseSalaryType: userSalaryType,
          salaryUnitPrice,
          projectHours: Object.values(workHoursByProjectId).filter(
            (projectHours) =>
              projectHours.totalHours > 0 ||
              projectHours.allowanceRows.length > 0
          ),
          assignmentHours: Object.values(workHoursByAssignmentId),
        });

        const foundUserTotals = userTotalWorkAmountsByUserId[resourceKey];

        // calculate each project worked total hours
        Object.values(workHoursByProjectId).forEach((projectHours) => {
          if (!totalProjectHoursByUserId[resourceKey]) {
            totalProjectHoursByUserId[resourceKey] = {};
          }
          const foundHours =
            totalProjectHoursByUserId[resourceKey][projectHours.projectId];

          if (!foundHours) {
            totalProjectHoursByUserId[resourceKey][projectHours.projectId] = {
              totalHours: 0,
              reducedTotalHours: 0,
            };
          }

          totalProjectHoursByUserId[resourceKey][
            projectHours.projectId
          ].totalHours += projectHours.totalHours;

          totalProjectHoursByUserId[resourceKey][
            projectHours.projectId
          ].reducedTotalHours += projectHours.reducedTotalHours;
        });

        // calculate each assignment worked total hours

        Object.values(workHoursByAssignmentId).forEach((assignmentHours) => {
          if (!totalAssignmentHoursByUserId[resourceKey]) {
            totalAssignmentHoursByUserId[resourceKey] = {};
          }
          const foundHours =
            totalAssignmentHoursByUserId[resourceKey][
              assignmentHours.assignmentId
            ];

          if (!foundHours) {
            totalAssignmentHoursByUserId[resourceKey][
              assignmentHours.assignmentId
            ] = {
              totalHours: 0,
              reducedTotalHours: 0,
            };
          }

          totalAssignmentHoursByUserId[resourceKey][
            assignmentHours.assignmentId
          ].totalHours += assignmentHours.totalHours;

          totalAssignmentHoursByUserId[resourceKey][
            assignmentHours.assignmentId
          ].reducedTotalHours += assignmentHours.reducedTotalHours;
        });

        if (foundUserTotals) {
          foundUserTotals.workTotalHours += Number(totalsum);
          foundUserTotals.workReducedHours += Number(finalReducedSum);
          foundUserTotals.totalWorkDays += Number(workdays);
          foundUserTotals.eachDayTotalHours =
            eachDayTotalHoursByUserId[resourceKey];
        } else {
          userTotalWorkAmountsByUserId[resourceKey] = {
            workTotalHours: Number(totalsum),
            workReducedHours: Number(finalReducedSum),
            totalWorkDays: workdays,
            userId: resourceKey,
            baseSalaryType: userSalaryType,
            personNumber: userPersonNumber,
            unitPrice: userHourlySalary,
            monthSalaryFrequency,
            projectTotals: totalProjectHoursByUserId[resourceKey],
            assignmentTotals: totalAssignmentHoursByUserId[resourceKey],
            eachDayTotalHours: eachDayTotalHoursByUserId[resourceKey],
          };
        }
      }
    });
    return rows;
  };

  let dataRows = [];
  let headerRows = [];
  Object.keys(weeks).map(function (week) {
    const _days = weeks[week];
    dataRows.push(mainTableRows(_days));
    headerRows.push(mainTableHeader(_days));
  });

  return { dataRows, headerRows, userTotalWorkAmountsByUserId };
};
